import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog } from '../../../common/components';
import LotTicketsDataTable from './components/LotTicketsDataTable';
import LotTicketsPagination from './components/LotTicketsPagination';
import LotTicketDialog from './components/LotTicketDialog';
import { useLotTicketsTable } from './hooks/useLotTicketsTable';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import usePermissions from '../../../hooks/usePermissions';

const LotTicketsTable = () => {
  const { permissions } = usePermissions();
  const canEditLots = Boolean(permissions?.canEditLots);
  const {
    data,
    lots,
    allotments,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedLotTicket,
    errors,
    districts,
    countries,
    provinces,
    departments,
    maritalStatuses,
    nationalities,
    availableLotsForDialog,
    deleteConfirmOpen,
    lotTicketToDelete,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleSave,
    handleEdit,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useLotTicketsTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <FormTitleBox
        title="Obra | Lotes | Boletos"
        showButton={true}
        buttonText="Agregar Boleto"
        buttonIcon={ConfirmationNumberIcon}
        onButtonClick={handleOpenDialog}
        buttonProps={{ disabled: !canEditLots }}
        showSearch={true}
        searchLabel="Buscar boleto"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <LotTicketsDataTable
        data={data}
        lots={lots}
        allotments={allotments}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        LoadingComponent={LoadingSkeleton}
        canEditLots={canEditLots}
      />

      <LotTicketsPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <LotTicketDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedLotTicket={selectedLotTicket}
        errors={errors}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        canEditLots={canEditLots}
        availableLots={availableLotsForDialog}
        districts={districts}
        countries={countries}
        provinces={provinces}
        departments={departments}
        maritalStatuses={maritalStatuses}
        nationalities={nationalities}
        allotments={allotments}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Eliminar Boleto"
        message={`¿Está seguro que desea eliminar el boleto de "${lotTicketToDelete?.full_name}"?`}
        confirmText="Eliminar boleto"
        confirmDisabled={!canEditLots}
      />
    </Box>
  );
};

export default LotTicketsTable;
